import { memo } from "react";
import SignUpCard from "./SignUpFormComponents/SignUpCard";
import LeftInformation from "../LeftInformation/LeftInformation";
import LoginBox from "../Login/LoginComponents/LoginBox";

function SignUpForm({ flipCard, seeLogin, setOpenResetDialog }) {
  return (
    <LoginBox>
      <LeftInformation
        flipCard={flipCard}
        loginPage={seeLogin}
        setOpenResetDialog={setOpenResetDialog}
      />
      <SignUpCard flipCard={flipCard} seeLogin={seeLogin} />
    </LoginBox>
  );
}

export default memo(SignUpForm);
